<template src='./list.pug' lang='pug'></template>

<script>
import _ from 'underscore'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import VueDragTree from '../../../registration/categories/TreeviewCategories'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import CategorieModal from '../../../registration/categories/CategorieModal'
import ConfirmModal from '../../../modals/confirmModal/ConfirmModal'
import customSorter from '../../../../utils/customSorter.js'
import { trackAnalyticsEvent } from '../../../../utils/analytics.js'

export default {
  name: 'CategoriesList',

  components: {
    PageTitle,
    VueDragTree,
    ButtonPrimary,
    CategorieModal,
    ConfirmModal
  },

  data () {
    return {
      categories: [],
      treeViewButtonTitle: {
        edit: this.$t('categoria.labels.editar'),
        create: this.$t('categoria.labels.criar'),
        expand: this.$t('categoria.labels.expandir'),
        collapse: this.$t('categoria.labels.recolher'),
        remove: this.$t('categoria.labels.remover'),
        removeBloq: this.$t('categoria.labels.removerBloqueado')
      },
      lastOrder: null,
      shown: false,
      idEditingCategory: null,
      lastCategoryOrder: 0,
      parentCategory: null,
      categoryIdToRemove: null,
      requestSentRemove: false
    }
  },

  computed: {
    isLoadingDataGeneral () {
      return this.$store.getters.isLoadingData
    }
  },

  watch: {
    shown () {
      if (!this.shown) {
        this.loadCategories()
      }
    }
  },

  methods: {
    // Método chamando nos botões do componente Treeview
    createEditCategory (categoryId, parentCategory, isEdit) {
      if (isEdit) {
        this.idEditingCategory = categoryId
      } else {
        this.parentCategory = parentCategory
        this.idEditingCategory = null
      }
      this.newCategory(categoryId, parentCategory)
      this.shown = true
    },

    getLastCategoryOrder (category) {
      if (!category) {
        return 0
      }
      if (category && category.children && category.children.length > 0) {
        return this.getLastCategoryOrder(category.children[category.children.length - 1])
      }

      return category.order
    },

    // Método que cria uma nova categoria
    newCategory (categoryId, parentCategory) {
      let lastCategory = _.last(this.categories)

      if (categoryId && parentCategory) {
        lastCategory = _.last(parentCategory.children)
      }

      this.lastCategoryOrder = this.getLastCategoryOrder(lastCategory)
    },

    // Carrega a listagem de categorias
    loadCategories () {
      this.$store.dispatch('loadingData').then(() => {
        this.$store.dispatch('getCategories', {
          url: '/categories/',
          flTipoCategoria: null,
          validarUso: true
        })
        .then((response) => {
          this.categories = response.data
          this.categories.forEach(cat => {
            if (cat.children && cat.children.length > 0) {
              cat.children = customSorter.arrayDottedSorter(cat.children, 'number', 'asc')
            }
          })
          this.$store.commit('SET_CATEGORIES_QTY', this.categories.length)
          this.$store.dispatch('dataLoaded')
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.data.message)
          this.$store.dispatch('dataLoaded')
        })
      })
    },

    handleRemove (categoryIdToRemove) {
      this.categoryIdToRemove = categoryIdToRemove
      $('#confirmRemoveCategory').modal('show')
    },

    removeCategory () {
      trackAnalyticsEvent(this, 'remove-click', 'remove-categoria', 'remove-categoria')
      if (this.categoryIdToRemove) {
        this.requestSentRemove = true
        this.$store.dispatch('removeCategorie', this.categoryIdToRemove)
          .then((response) => {
            this.$root.$refs.notification.success('categoria.sucesso.remover')
            this.categoryIdToRemove = null
            $('#confirmRemoveCategory').modal('hide')
            this.loadCategories()
          })
          .catch((error) => {
            this.$root.$refs.notification.error(error.message)
          })
          .finally(() => {
            this.requestSentRemove = false
          })
      }
    },

    closeModalConfirm () {
      this.categoryIdToRemove = null
      $('#confirmRemoveCategory').modal('hide')
    }
  },

  created () {
    this.loadCategories()
  }
}
</script>

<style>
.clear {
  clear: both;
}

#categories {
  margin-top: 15px;
}

.categories-header {
  font-family: 'Inter', sans-serif;
font-weight: 700;
  background-color: #223763;
  color: #FFF;
  height: 30px;
  padding: 5px 15px;
  font-size: 14px;
  border-radius: 12px 12px 0px 0px;
}

.categories-header-acoes-tit {
  float:right;
  width: 86px;
  text-align: right;
  padding: 0px 5px 0px 0px;
}

.categories-header-column-left {
  padding-left: 0px;
  margin-left: 18px;
  margin-right: 6px;
}

.categories-type {
  margin-left: 3px;
}

.categories-initial-balance {
  text-align: right;
}

.categories-initial-balance-date {
  text-align: right;
}

.actions {
  text-align: center;
}

.action {
  text-align: center;
  background-color: transparent !important;
  border: none !important;
  margin: 0 5px 0 5px;
}

.action:hover {
  border: none !important;
}

.action:disabled {
  cursor: not-allowed;
}

.isLoadingDataGeneral {
  background: url(../../../../assets/loading-gif/loading.svg) 50% 50% no-repeat;
  background-color: #EEE;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  opacity: 0.8;
  overflow-y: hidden;
  cursor: wait;
  background-size: 150px;
  -webkit-transition: all 5s ease-in-out;
  -moz-transition: all 5s ease-in-out;
  -ms-transition: all 5s ease-in-out;
  -o-transition: all 5s ease-in-out;
  transition: all 5s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// List.vue?08306c9e